import { useContext } from 'react';
import { ObjectBrokerItem } from './ObjectBrokerItem';
import { ObjectPageContext } from '../../pages/Context/ObjectPageContext';

export default function ObjectBroker() {
  const { estate } = useContext(ObjectPageContext);

  return (
    <div className="mb-4 lg:mb-0 bg-blue100 px-3 lg:px-4 pb-6 pt-4 lg:py-0 xxl:px-6 min-h-[223px] lg:min-h-[200px]">
      <div className="md:flex md:gap-4 lg:gap-0 lg:block">
        {estate?.brokers &&
          estate?.brokers !== undefined &&
          estate?.brokers.map((brokerItem: any, index: number) => (
            <ObjectBrokerItem
              key={brokerItem?.id}
              broker={brokerItem}
              indexNo={index}
            />
          ))}
      </div>

      <div className="my-4 mb-0 lg:mb-6 lg:mt-6 font-icb w-full">
        {estate?.officeInfo?.url && estate?.officeInfo?.name && (
          <a
            className="flex justify-center items-center hover-move-arrow text-blue700"
            href={`https://${estate?.officeInfo?.url?.replace('https://', '')}`}
            target="_blank"
          >
            <span>Till kontoret {estate?.officeInfo?.name}</span>
            <img
              width="20"
              height="12"
              className="w-5 ml-3 arrow-move"
              src={'/Images/Icons/Arrows/arrow-right-blue700.svg'}
              loading="lazy"
              alt="Arrow right icon"
            />
          </a>
        )}
      </div>
    </div>
  );
}
